module.exports = __webpack_public_path__ + "img/dark-cloudy-rain.9f951b5f.svg";